import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }

import { Search, Refresh, Plus } from '@element-plus/icons-vue'
import type { FormInstance } from 'element-plus'
import { onBeforeMount, reactive, ref, getCurrentInstance, onMounted } from 'vue'
import { gradelist, subjectSubject, bureauClassRooList, viewAudioReport } from '@/api/home'
import FileSaver from 'file-saver'

export default /*#__PURE__*/_defineComponent({
  __name: 'bureau_teaching_eval',
  setup(__props) {

const { proxy } = getCurrentInstance()
const { roleType, schoolId, orgId } = proxy.$store.state
let loading = ref(false)
let total = ref(0)

const queryParams = reactive({
  schoolName: '',
  teacherName: '',
  subjectCode: '',
  reportStatus: '',
  pageNum: 1,
  pageSize: 20,
  classId: '',
  gradeId: '',
  orgId: orgId,
  countryOrg: '',
  cityOrg: '',
  provinceOrg: '',

})



let schoolList = ref([])

const queryForm = ref<FormInstance>()

const indexMethod = (index: number) => {
  return index + 1 + (queryParams.pageNum - 1) * 20
}

// 状态
const statesList = ref<
  {
    code: string
    name: string
  }[]
>([
  {
    code: '1',
    name: '已生成',
  },
  {
    code: '0',
    name: '待生成',
  },
])

const statusTypeObj = ref({
  1: '已生成',
  0: '待生成',
})




onMounted(() => {
  init()
  getGradeList()
  getSubjectList()
  getList()
})

/** 查询按钮操作 */
const handleQuery = () => {
  queryParams.pageNum = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = (form: FormInstance | undefined) => {
  if (!form) return
  form.resetFields()
  init()
  handleQuery()
}


const downLoadUrl = (row) => {
  let fileUrl
  if (row.fileUrl.includes('http')) {
    fileUrl = encodeURI(row.fileUrl)
  } else {
    fileUrl = encodeURI(row.serverHttp + row.fileUrl)
  }
  if (fileUrl) {
    FileSaver.saveAs(fileUrl, row.fileName);
  }

}





const areaCode = ref<{
  province: string
  city: string
  area: string
}>({
  province: '',
  city: '',
  area: ''
})

const init = async () => {

  // const { countyOrg, cityOrg, provinceOrg, } = JSON.parse(localStorage.getItem('userInfo')) || {}
  const { countyOrg, cityOrg, provinceOrg, areaLevel } = JSON.parse(localStorage.getItem('userInfo')) || {}
  areaCode.value = {
    province: provinceOrg,
    city: cityOrg,
    area: countyOrg
  }
  if (areaLevel == 'county') {
    queryParams.countryOrg = countyOrg
    disabledArea.value.countryDis = true
    disabledArea.value.cityDis = true
    disabledArea.value.provinceDis = true

  }
  if (areaLevel == 'city') {
    queryParams.cityOrg = cityOrg
    disabledArea.value.countryDis = false
    disabledArea.value.cityDis = true
    disabledArea.value.provinceDis = true

  }
  if (areaLevel == 'province') {
    queryParams.provinceOrg = provinceOrg
    disabledArea.value.countryDis = false
    disabledArea.value.cityDis = false
    disabledArea.value.provinceDis = true
  }

}

//查询列表
const disabledArea = ref({
  countryDis: true,
  cityDis: true,
  provinceDis: true

})
const getList = async (pageNum = undefined) => {
  queryParams.pageNum = pageNum ? pageNum : 1
  let response = await bureauClassRooList(queryParams)
  if (response && response.code == 0) {
    const { totalCount, dataList } = response.data
    schoolList.value = dataList
    total.value = totalCount
  }
}

//查询学校科目
let subjectCodeOptions = ref([])
let subjectCodeObj = ref({})

const getSubjectList = async (e = undefined) => {
  let response = await subjectSubject(e)
  if (response && response.code == 0) {
    subjectCodeOptions.value = response && response.data
    subjectCodeObj.value = getRole(response.data)
  }
}

const getRole = (list) => {
  let obj = {}
  if (!list) return {}
  list.forEach((item) => {
    obj[item.id] = item.name
  })
  return obj
}


// 只能修改添加当前班级
let gradeList = ref([]) // 年级
// 年级列表
const getGradeList = async () => {
  const response = await gradelist({ schoolId });
  if (!response) return
  gradeList.value = response.data;
};

/**
* 年级切换获取学科
*/
const handleGradeSelect = async (e) => {
  if (!e) return
  queryParams.classId = ''
  getSubjectList(e)

}


// 查看报告

let reportVisible = ref(false)
const rowData = ref({
  operat: false,
})

const handleReport = async (row) => {
  // rowData.value.operat = true
  if (!row.id) return
  const response = await viewAudioReport(row.id)
  if (response && response.code == 0) {
    reportVisible.value = true
    rowData.value = {
      ...row,
      ...response.data,
    }
  }
}

/**
 * 查看报告回调函数
 */
const reportClosed = async (val) => {
  console.log(val)
  rowData.value.analysisTime = ""
  reportVisible.value = false
}
const reportConfirm = async (val) => {
  console.log(val)
  reportVisible.value = false
  getList()
}





//接收省市区地址选择组件函数
const provinceCode = (data: any) => {
  queryParams.provinceOrg = data
  queryParams.cityOrg = ''
  queryParams.countryOrg = ''
}
const cityCode = (data: any) => {
  queryParams.cityOrg = data
  queryParams.countryOrg = ''

}
const countyCode = (data: any) => {
  queryParams.countryOrg = data

}







return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_citys = _resolveComponent("citys")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_report = _resolveComponent("report")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          class: "col-header"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createTextVNode(" 教学评价管理 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: queryParams,
          ref_key: "queryForm",
          ref: queryForm,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "areaCode",
              label: "省市区"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_citys, {
                  onCountyCode: countyCode,
                  onProvinceCode: provinceCode,
                  onCityCode: cityCode,
                  addressCode: areaCode.value,
                  disabled: false,
                  disabledArea: disabledArea.value
                }, null, 8, ["addressCode", "disabledArea"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学校",
              prop: "schoolName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入学校名称",
                  modelValue: queryParams.schoolName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.schoolName) = $event)),
                  autocomplete: "off",
                  class: "input-with-select"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "教师",
              prop: "teacherName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入教师姓名",
                  modelValue: queryParams.teacherName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.teacherName) = $event)),
                  autocomplete: "off",
                  class: "input-with-select"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "gradeId",
              label: "年级"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.gradeId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.gradeId) = $event)),
                  placeholder: "年级",
                  clearable: "",
                  onChange: handleGradeSelect
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "科目",
              prop: "subjectCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.subjectCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.subjectCode) = $event)),
                  placeholder: "请选择科目",
                  clearable: "",
                  disabled: !queryParams.gradeId
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectCodeOptions), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "reportStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.reportStatus,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.reportStatus) = $event)),
                  placeholder: "请选择状态",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statesList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _unref(Search),
                  type: "primary",
                  size: "mini",
                  onClick: handleQuery
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(Refresh),
                  size: "mini",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (resetQuery(queryForm.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(schoolList),
          border: "",
          style: {"margin-bottom":"20px"},
          "header-cell-style": { background: '#FAFAFA' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "120",
              type: "index",
              index: indexMethod
            }),
            _createVNode(_component_el_table_column, {
              label: "教师",
              align: "center",
              prop: "teacherName"
            }),
            _createVNode(_component_el_table_column, {
              label: "班级",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row.gradeList && row.gradeList[0]? row.gradeList[0].gradeName +  row.gradeList[0].className :''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "科目",
              align: "center",
              prop: "subjectName"
            }),
            _createVNode(_component_el_table_column, {
              label: "课题",
              align: "center",
              prop: "topic"
            }),
            _createVNode(_component_el_table_column, {
              label: "音频",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  onClick: ($event: any) => (downLoadUrl(row.audioAnnex))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 点击下载")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "学校",
              align: "center",
              prop: "schoolName"
            }),
            _createVNode(_component_el_table_column, {
              label: "报告",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(statusTypeObj.value[row.reportStatus]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "上传时间（分）",
              align: "center",
              prop: "classHour"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "300"
            }, {
              default: _withCtx(({row}) => [
                (row.reportStatus == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      link: "",
                      size: "small",
                      onClick: ($event: any) => (handleReport(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(loading)]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, prev, pager, next",
          total: _unref(total),
          "page-size": queryParams.pageSize,
          "current-page": queryParams.pageNum,
          onCurrentChange: getList
        }, null, 8, ["total", "page-size", "current-page"])
      ]),
      _: 1
    }),
    (_unref(reportVisible))
      ? (_openBlock(), _createBlock(_component_report, {
          key: 0,
          visible: _unref(reportVisible),
          data: rowData.value,
          onClosed: reportClosed,
          onConfirm: reportConfirm
        }, null, 8, ["visible", "data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})